import { zodResolver } from '@hookform/resolvers/zod'
import { type TFunction } from 'i18next'
import { z } from 'zod'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { defaultDocumentReportTitleI18nKey } from '~/utils'

export const pathKey = 'documentReportEdit' satisfies PathKey

// eslint-disable-next-line jsdoc/require-param, jsdoc/require-returns
/**
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
const createSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1).default(t(defaultDocumentReportTitleI18nKey)),
    content: z.string().default(''),
  })

export type InputValues = z.infer<ReturnType<typeof createSchema>>
// eslint-disable-next-line jsdoc/require-param, jsdoc/require-returns
/**
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export const createResolver = (t: TFunction) => zodResolver(createSchema(t))
